import React from 'react';
import './sec7.css'
import Contactinfo from '../components/common/contact-info-sec7';
import pic26 from'../assets/pic26.png'
import pic27 from'../assets/pic27.png'
import pic28 from'../assets/pic28.png'
import pic29 from'../assets/pic29.png'
import Input from '../components/common/input';
import Textarea from '../components/common/textarea';
import Cta from '../components/common/cta';
import gsap from 'gsap';
import { useEffect } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { supabase } from '../supabase';
import { useState } from 'react';
import Popup from '../components/common/popup';
import { useRef } from 'react';
import Mapcomponent from '../components/common/map'
import pic77 from '../assets/pic77.png'

gsap.registerPlugin(ScrollTrigger);


const Sec7 = () => {
const [content, setcontent]= useState([]);
const [errors, setErrors] = useState({});
const [msg ,setmsg]= useState('');
const [name, setName] = useState('');
const [email, setEmail] = useState('');
const [popup, setpopup] = useState('');
const [showPopup, setShowPopup] = useState(false);
const closePopup = () => {
  setShowPopup(false);
};


const validate = () => {
  const newErrors = {};
  let isValid = true;

  if (!name.trim()) {
    newErrors.name = "Name is required";
    isValid = false;
  }

  if (!email.trim()) {
    newErrors.email = "Email is required";
    isValid = false;
  } else if (!/\S+@\S+\.\S+/.test(email)) {
    newErrors.email = "Invalid email format";
    isValid = false;
  }

  if (!msg.trim()) {
    newErrors.msg = "Message is required";
    isValid = false;
  }

  setErrors(newErrors);

  return isValid;
};














const createmsg = async(e)=> {
   e.preventDefault(); 

  if (!validate()) return;
 let userId;


  const { data: existingUser } = await supabase
    .from('users')
    .select('*')
    .eq('user_email', email)
    .maybeSingle();

  if (existingUser) {
    userId = existingUser.id;
  } else {

    const { data: newUser, error } = await supabase
      .from('users')
      .insert([
        {
          user_name: name,
          user_email: email
        }
      ])
      .select();

    if (error) {
      console.log("User insert error:", error);
      return;
    }

    userId = newUser[0].id;
  }

  const res = await supabase.from ('messages').insert([
      {
        message: msg,
        user_id: userId
      }
    ]);


await supabase.from('messages').insert([
  {
    message: msg,
    user_id: userId
  }
]);

setShowPopup(true);


setName('');
setEmail('');
setmsg('');
setErrors({});
setShowPopup(true);



}



const secRef = useRef(null);


useEffect(() => {


  const el = secRef.current;
  if (!el) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        el.classList.remove("in-view");
        void el.offsetHeight;
        el.classList.add("in-view");
      } else {
        el.classList.remove("in-view");
      }
    },
    { threshold: 0 }
  );

  observer.observe(el);

  return () => observer.disconnect();

}, []);



useEffect(() => {
const getcontent = async()=>{
    const res = await supabase.from('static_content').select('*').order('id', { ascending: true });;

setcontent(res.data);
}
getcontent();
}, []);







useEffect(() => {
const getpopup = async()=>{
    const res = await supabase.from('Popup_content').select('*').order('id', { ascending: true });;

setpopup(res.data);
}
getpopup();
}, []);


 const [location, setlocation]= useState([]);
 useEffect(() => {
  const getlocation = async () => {
    const { data, error } = await supabase
      .from('exbition_event')
      .select('*')
.eq('status', 'ongoing')
  .limit(1)
  .single();           

    console.log("LOCATION DATA:", data); 

    if (error) console.error(error);
    else setlocation(data);
  };

  getlocation();
}, []);



useEffect(() => {
  ScrollTrigger.refresh();
}, [content]);


    return ( 
        <section className='sec7' ref={secRef}>
            <section className='container-cards-sec7'>
                <section className='big-cont-sec7'>
                <section className='main-cont-sec7'>
                    <h1 className='header-sec7'>{content?.[4]?.header}</h1>
                    <section className='container-cards-contact'>
                        <article className='card-left'>
                                <article className='container-contact-info-row'>
                                        <Contactinfo img={pic26}
                                        alt='email'
                                         tite='Email'
                                        sent={content?.[5]?.sentence}/>

                                        <Contactinfo img={pic27}
                                        alt='Phone'
                                         tite='Phone'
                                         sent={content?.[6]?.sentence}/>

                                        <Contactinfo img={pic28}
                                         alt='Location'
                                         tite='Location'
                                         sent={content?.[7]?.sentence}/>

                                </article>

                                <figure className='map-sec7' >
                                <Mapcomponent  lat={location?.lat} lng={location?.lng}  />
                                </figure>
                        </article>

                        <form className='card-right' onSubmit={createmsg}>
                                  <fieldset className='fieldsett2'>                        
                                    <Input title='User Name' type='text'
                                    placeholder='Enter your name' 
                                    value={name}
                                    onChange={(e)=> setName(e.target.value)} 
                                     />
                                  
                                  {errors.name && 
                                    <div className='container-input-errror'>
                                      <img src={pic77} alt='error icon'></img>
                                    <p className="error">{errors.name}</p>
                                    </div>
                                    }
                                </fieldset>                                      
                                  <fieldset className='fieldsett2'>
                                    <Input title='User Gmail'
                                     type='email'
                                    placeholder='Enter your Gmail'
                                    value={email}
                                    onChange={(e)=> setEmail(e.target.value)}  />
                                    {errors.email && 
                                    <div className='container-input-errror'>
                                      <img src={pic77} alt='error icon'></img>
                                    <p className="error">{errors.email}</p>
                                    </div>
                                    }
                                </fieldset>
                                  <fieldset className='fieldsett2'>
                                    <Textarea title='Message' type='text'
                                    stylee='textareaa'
                                     placeholder='Enter your message'
                                     value={msg} 
                                     onChange={(e)=> setmsg(e.target.value)}  />

                                  {errors.msg && 
                                    <div className='container-input-errror'>
                                      <img src={pic77} alt='error icon'></img>
                                    <p className="error">{errors.msg}</p>
                                    </div>
                                    }

                                </fieldset>
                                    <Cta  title={content?.[4]?.cta}  />

                        </form>

                    </section>
                </section>
                </section>
            </section>
{showPopup && (
          <Popup
          to="/" 
            onClose={closePopup}
           img={popup?.[0]?.image} 
            alt={popup?.[0]?.icon_alt} 
          header={popup?.[0]?.title}
           para={popup?.[0]?.paragraph} 
           title={popup?.[0]?.cta_text_primary} 
          />
)}
        </section>
     );
}
 
export default Sec7;